import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const quickFilters = ['All tasks', 'Projects', 'Booking', 'Files', 'People'];

const ToolFilters = ({
  searchQuery,
  onSearchChange,
  taskFilter,
  onTaskChange,
  resultCount,
  compact,
  onToggleCompact,
  categories,
  activeCategory,
  onCategoryChange,
}) => (
  <div className="mb-7">
    <div className="flex flex-col md:flex-row gap-3 md:items-center">
      <label className="relative flex-grow">
        <SafeIcon
          name="Search"
          className="absolute left-4 top-1/2 -translate-y-1/2 text-sm text-slate-400"
        />
        <input
          value={searchQuery}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Try “leave”, “expenses”, “logos”, “footage” or “desk”..."
          className="tool-search w-full py-3.5 pl-11 pr-10 text-sm outline-none"
        />
        <AnimatePresence>
          {searchQuery && (
            <motion.button
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              type="button"
              onClick={() => onSearchChange('')}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
              aria-label="Clear search"
            >
              <SafeIcon name="X" />
            </motion.button>
          )}
        </AnimatePresence>
      </label>

      <button
        type="button"
        onClick={onToggleCompact}
        className="view-toggle"
        aria-pressed={compact}
      >
        <SafeIcon name={compact ? 'Grid' : 'List'} />
        {compact ? 'Grid view' : 'Compact view'}
      </button>

      <span className="result-count">
        {String(resultCount).padStart(2, '0')} results
      </span>
    </div>

    <div className="mobile-category-filters hide-scrollbar">
      {categories.map((category) => (
        <button
          key={category}
          type="button"
          onClick={() => onCategoryChange(category)}
          className={activeCategory === category ? 'active' : ''}
        >
          {category}
        </button>
      ))}
    </div>

    <div className="flex gap-2 mt-3 overflow-x-auto hide-scrollbar">
      {quickFilters.map((filter) => (
        <button
          key={filter}
          type="button"
          onClick={() => onTaskChange(filter)}
          className={`task-filter ${taskFilter === filter ? 'active' : ''}`}
        >
          {filter}
        </button>
      ))}
    </div>
  </div>
);

export default ToolFilters;